<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${serviceSlug}`), disabled: true },
        { title: $t('clinical.canceled_call_requests.title'), disabled: true }
      ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <CanceledCallRequestsTable
      ref="tableView"
      :clinicalServiceId="component.clinical_service_id"
      :service="component.service"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
      @row-clicked="onRowClicked"
    />

    <CanceledCallRequestDetailsModal
      v-if="showCanceledCallRequestDetailsModal"
      :callRequestAppointment="callRequestAppointment"
      @modalClosed="onCanceledCallRequestsModalCanceled"
    />

  </div>
</template>
<script>
import Filters from '@/components/common/Filters'
import Searchable from '@/components/common/Searchable'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import IndexTablesMixin from '@/mixins/IndexTablesMixin'
import { TABLE_CLINICAL_CANCELED_CALL_REQUESTS } from '@/local-storage/LocalStorageKeys'
import CanceledCallRequestsTable from '@/components/clinical/canceled-call-requests/CanceledCallRequestsTable'
import CanceledCallRequestDetailsModal
  from '@/components/clinical/canceled-call-requests/CanceledCallRequestDetailsModal'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  mixins: [
    IndexTablesMixin
  ],
  components: {
    CanceledCallRequestDetailsModal,
    CanceledCallRequestsTable,
    Filters,
    Searchable,
    Breadcrumbs
  },
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_CLINICAL_CANCELED_CALL_REQUESTS,
      callRequestAppointment: null,
      showCanceledCallRequestDetailsModal: false,
      customQueries: null
    }
  },

  methods: {
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
      if (activeFilters > 0) {
        this.showFilters = true
      }
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onRowClicked: function ({ callRequestAppointment }) {
      this.callRequestAppointment = callRequestAppointment
      this.showCanceledCallRequestDetailsModal = true
    },
    onCanceledCallRequestsModalCanceled: function () {
      this.showCanceledCallRequestDetailsModal = false
      this.callRequestAppointment = null
    }
  }
}
</script>
